import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import moment from "moment";
import { DashboardService } from "../dashboard.service";

export interface DialogData {
  action: "create" | "update";
  consultId: string;
}

interface FollowUpCount {
  type: string;
  count: number;
}

enum FollowUpType {
  PARENT = "parent",
  CHILDREN = "children",
}
@Component({
  selector: "app-schedule-follow-up-consultation",
  templateUrl: "./schedule-follow-up-consultation.component.html",
  styleUrls: ["./schedule-follow-up-consultation.component.scss"],
})
export class ScheduleFollowUpConsultationComponent implements OnInit {
  loading: boolean = true;
  error: boolean = false;

  countParent: number = 0;
  countChildren: number = 0;

  minDate = moment().add(1, "day").toDate();
  date = new FormControl(this.minDate);
  DATE_FORMAT = "YYYY-MM-DD";

  constructor(
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    private dateAdapter: DateAdapter<Date>,
    public dialogRef: MatDialogRef<ScheduleFollowUpConsultationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.dateAdapter.setLocale("es-ES"); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.onDateChange();
  }

  resetCounts(): void {
    this.countChildren = 0;
    this.countParent = 0;
  }

  onDateChange(): void {
    this.loading = true;
    this.error = false;
    const date = moment(this.date.value);

    if (date.isValid()) {
      this.countParent = 0;
      this.countChildren = 0;

      const params = {
        startDate: date.format(this.DATE_FORMAT),
      };

      this.dashboardService.followUpCount(params).subscribe({
        next: (result) => {
          this.loading = false;
          this.resetCounts();

          result?.data?.count?.forEach((item) => {
            if (item.type === "children") {
              this.countChildren = item.count;
            } else {
              this.countParent = item.count;
            }
          });
        },
        error: () => {
          this.loading = false;
          this.error = true;
        },
      });
    } else {
      this.loading = false;
      this.error = true;
    }
  }

  save(): void {
    const date = moment(this.date.value);

    if (date.isValid()) {
      if (this.data.action === "create") {
        this.dialogRef.close({
          event: this.data.action,
          data: { followUpDate: moment(date).format(this.DATE_FORMAT) },
        });
      } else if (this.data.action === "update") {
        this.dialogRef.close({
          event: this.data.action,
          data: { followUpDate: moment(date).format(this.DATE_FORMAT) },
        });
      }
    }
  }
}
